<div *ngIf="loading" class="loading-text">
    <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
    <app-sub-header [pageTitle]="'OdometerInput' | translate"></app-sub-header>

    <div class="padded-container">
        <div *ngIf="odometerResponse?.odometerValue">
            <dx-form [formData]="odometerResponse" [colCount]="1">
                <dxi-item itemType="group" caption="{{ 'OdometerStartValue' | translate }}">
                    <dxi-item>
                        <dx-number-box [(value)]="startOdometerValue" [showSpinButtons]="true" [min]="odometerResponse?.odometerValue?.odometerEndVal"></dx-number-box>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="{{ 'StartTime' | translate }}">
                    <dxi-item>
                        <div class="row">
                            <div class="col-6">
                                <dx-select-box [(value)]="startHours" [items]="hours"></dx-select-box>
                            </div>
                            <div class="col-6">
                                <dx-select-box [(value)]="startMinutes" [items]="minutes"></dx-select-box>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="{{ 'Date' | translate }}">
                    <dxi-item>
                        <dx-date-box [(value)]="chosenDate" displayFormat="dd/MM/yyyy"></dx-date-box>
                    </dxi-item>
                    <dxi-item>
                        <div class="button-container">
                            <dx-button class="half-width-button" type="default"
                                [text]="isMobile ? '<' : ('PreviousDay' | translate)" 
                                (onClick)="dayBack()">
                            </dx-button>
                            <dx-button class="half-width-button" type="default" 
                                [text]="isMobile ? '>' : ('NextDay' | translate)" 
                                (onClick)="dayForward()">
                            </dx-button>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
            <dx-button
                class="full-width-button"
                text="{{ 'Save' | translate }}"
                type="default"
                (onClick)="startVoucher()"
                [disabled]="isButtonDisabled">
            </dx-button>
            <dx-button
                class="full-width-button"
                text="{{ 'Back' | translate }}"
                type="default"
                (onClick)="goback()">
            </dx-button>
        </div>
        <div *ngIf="!odometerResponse?.odometerValue">
            <span>{{ 'Loading data, please wait...' | translate }}</span>
        </div>
    </div>
</div>